<template>
  <div>
    <v-card :loading="loading" class="p-5 w-100">
      <v-row no-gutters>
        <v-col class="pa-2 text-left" cols="12">
          <v-btn class="mt-5s btn-list my-0" outlined @click="$router.push({name:'pureData'})">
            <span class="fa fa-list ml-2" style="font-size: 10pt"></span>
            لیست بدون کارت ویزیت
          </v-btn>

          <v-menu content-class="custom-scrollbar" min-width="200" offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="mt-5s btn-send-sms my-0" outlined v-on="on">
                <span class="fa fa-plus ml-2" style="font-size: 10pt"></span>
                افزودن مدل جدید
              </v-btn>
            </template>

            <v-list>
              <v-list-item v-for="(item, index) in menuItems" :key="index" :value="item.value"
                           @click="createPage(item.value)">
                <v-list-item-title v-text="item.title"/>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-btn class="mt-5s btn-list my-0" outlined @click="smartList=true">
            <span class="fa fa-list ml-2" style="font-size: 10pt"></span>
            لیست ارسالی ها
          </v-btn>
        </v-col>
      </v-row>

      <vue-table :data="data" :headers="headers" :props.sync="tableProps" @change="onPagination" @click:row="rowClick">
        <template v-slot:filters="{props, perPage}">
          <v-row no-gutters>
            <v-col class="pa-2" cols="12" lg="2" md="3" sm="6">
              <v-select v-model="props.length" :items="perPage" class="rounded-lg" dense hide-details
                        label="تعداد نمایش" outlined/>
            </v-col>

            <v-col class="pa-2" cols="12" lg="2" md="3" sm="6">
              <v-autocomplete v-model="props.type" :items="models" class="rounded-lg" dense label="نوع مدل" outlined/>
            </v-col>
          </v-row>
        </template>

        <template v-slot:created_at="{item}">
          {{ datetime(item.created_at, 'date') }}
        </template>

        <template v-slot:type="{item}">
          {{ item.type | typeText }}
        </template>

        <template v-slot:manage="{item}">
          <v-btn color="warning" outlined small @click.stop="editRoute(item.type, item.id)">ویرایش
            <v-icon>edit</v-icon>
          </v-btn>

          <v-btn class="mx-2" color="red" outlined small @click.stop="deleteTemplate(item.id)">حذف
            <v-icon>delete</v-icon>
          </v-btn>
        </template>
      </vue-table>
    </v-card>

    <custom-popup id="gallery" v-model="priceDialog" :cons="{title: 'ارسال هوشمند'} " hide-confirm
                  max-width="700">
      <v-card class="p-8">
        <v-autocomplete v-model="type" :items="qrTypes" class="mb-1" dense label="انتخاب دسته" outlined/>

        <v-text-field v-model="adsLink" dense hide-details label="لینک آگهی" outlined/>
        <v-text-field v-model="title" class="my-4" dense hide-details label="عنوان دسته" outlined/>
        <v-text-field v-if="['personal', 'real-estate-business'].includes(type) " v-model="payLoad" class="my-4" dense
                      hide-details label="payload" outlined/>
        <v-btn :loading="loading" class="mt-10 btn-send-sms " outlined @click="sendPattern">
          <span class="fa fa-save ml-2" style="font-size: 10pt"></span>
          ارسال
        </v-btn>

      </v-card>
    </custom-popup>

    <custom-popup id="gallery" v-model="smartList" :cons="{title: 'لیست ارسالی ها'} " hide-confirm max-width="900">
      <v-card class="p-8">
        <smart-list v-if="smartList"/>
      </v-card>
    </custom-popup>
  </div>
</template>

<script>
import { readUint16 } from "ag-psd/dist/psdReader";
import PatternsList from "./patternsList";
import SmartList from "./smartList";

export default {
  name: "modelsList",

  components: {SmartList, PatternsList},

  filters: {
    typeText(input) {
      switch (input.toLowerCase()) {
        case 'productmodel':
          return 'معرفی محصول'
        case 'simplebpage':
          return 'بیزینس پیج'
        case 'shoppage':
        case 'bshop':
          return 'فروشگاه'
        case 'menu':
          return 'منو'
        case 'visitcard':
          return 'کارت ویزیت'
        case 'gift':
          return 'قاب خاطره'
        case 'visitcardpro':
          return 'کارت ویزیت پرو'
        case 'productpro':
          return 'معرفی محصول پرو'
        case 'photogallery':
          return 'گالری تصویر'
        case 'pdfgallery':
          return 'گالری پی دی اف'
         case 'socialmedia':
         return 'شبکه اجتماعی'
         case 'labelproduct':
         return 'لیبل محصول'

        default:
          return input

      }
    }
  },

  data() {
    return {
      loading: false,
      priceDialog: false,
      menuItems: [
        {title: 'منو', value: '/qr/createModel/menu'},
        {title: 'کارت ویزیت', value: '/qr/create/models'},
        {title: 'بیزینس پیج', value: '/qr/create/business'},
        {title: 'فروشگاه آنلاین', value: 'qr/create/shopPage'},
        {title: 'معرفی محصول', value: '/qr/create/productModel'},
        {title: 'قاب خاطره', value: '/qr/create/memoriesModel'},
        {title:'کارت ویزیت پرو',value:'/qr/create/cardVisitProModel'},
        {title:'معرفی محصول پرو',value:'/qr/create/productProModel'},
        {title:'گالری تصویر',value:'/qr/create/photoGalleryModel'},
        {title:'گالری pdf',value:'/qr/create/pdfGalleryModel'},
        {title:'شبکه اجتماعی',value:'/qr/create/SocialMediaModel'},
        {title:'لیبل محصول',value:'/qr/create/ProductLabelModel'},

      ],
      smartList: false,
      isEditing: false,
      models: [
        {text: 'همه', value: ''},
        {text: 'کارت ویزیت', value: 'visitCard'},
        {text: 'منو', value: 'menu'},
        {text: 'بیزینس پیج', value: 'business'},
        {text: 'فروشگاه آنلاین', value: 'bShop'},
        {text: 'معرفی محصول', value: 'product'},
        {text:'قاب خاطره',value: 'gift'},
        {text:'کارت ویزیت پرو',value: 'visitcardpro'},
        {text:'معرفی محصول پرو',value: 'productpro'},
        {text:'گالری تصویر',value: 'PhotoGallery'},
        {text:'گالری pdf',value: 'PdfGallery'},
        {text:'شبکه اجتماعی',value: 'SocialMedia'},
        {text:'لیبل محصول',value: 'labelProduct'},
      ],
      adsLink: '',
      title: '',
      payLoad: '',
      qrId: '',
      description: {},
      modelType: '',
      type: '',
      data: {},
      headers: [
        {value: 'id', text: 'شناسه', sortable: false, align: 'center'},
        {value: 'title', text: 'نام مدل', sortable: false, align: 'center'},
        {value: 'created_at', text: 'تاریخ ساخت', sortable: false, align: 'center'},
        {value: 'type', text: 'نوع', sortable: false, align: 'center'},
        {value: 'manage', text: 'مدیریت', sortable: false, align: 'center'},
      ],
      tableProps: {
        page: 1,
        length: 100,
        type: '',
        dir: 'desc'
      },
      qrTypes: [
        {
          text: 'آژانس املاک',
          value: 'real-estate-business'
        },
        {
          text: 'نمایشگاه ماشین',
          value: 'car-business'
        },
        {
          text: 'شخصی',
          value: 'personal'
        },
        {
          text: 'صادرات',
          value: 'expert'
        },
        {
          text: 'فروشگاهی',
          value: 'marketplace'
        },
        {
          text: 'مشاغل',
          value: 'job-business'
        },
        {
          text: 'مشاور املاک',
          value: 'agent-real-estate-business'
        },
        {
          text: 'بنگاه ماشین',
          value: 'car-concierge-business'
        },
      ],
    }
  },

  mounted() {
    this.getData()
  },

  methods: {
    getData(params = this.tableProps) {
      this.loading = true;

      this.$api.get(`/qr/template`, {params})
        .then(({data}) => this.data = data.data)
        .catch(reason => {
          this.$modal.error('خطا', 'در دریافت اطلاعات با خطا مواجه‌ شدیم.');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onPagination(e) {
      let obj = {
        ...this.tableProps,
        ...e
      }

      this.getData(obj)
    },
    rowClick(e) {
      this.priceDialog = true
      this.qrId = e.id
    },
    reseData() {
      this.description = {};
      this.type = '';
      this.modelType = '';
      this.adsLink = '';
      this.priceDialog = false;
    },
    sendPattern() {
      this.$api.post('/api/smart', {
        'qr_id': this.qrId,
        'payload': {
          link: this.adsLink,
          title: this.title,
          payload: ['personal', 'real-estate-business'].includes(this.type)
            ? this.payLoad.replace(/"page":.*?,/, '').replace(/,"last-post-date":\d+/, '')
            : undefined
        },
        'type': this.type
      })
        .then(() => {
          this.loading = false;
          this.$toast.success('درخواست شما با موفقیت ثبت شد.');
          this.reseData();
        })
        .catch((err) => {
          this.loading = false;
          this.$toast.error('خطا!');
        })
        .finally(() => {
          this.loading = false;
        })
    },
    editRoute(type_pram, id) {
      let type = type_pram.trim().toLowerCase();
      console.log(type,"type")
      if (type === 'productmodel')
        this.$router.push(`modelsList/${id}/productCard`)
      else if (type === 'simplebpage')
        this.$router.push(`modelsList/${id}/business`)
      else if (['shoppage', 'bshop'].includes(type.toLowerCase()))
        this.$router.push(`modelsList/${id}/editBShop`)
      else if (type === 'visitcard')
        this.$router.push(`modelsList/${id}/edit`)
      else if (type === 'menu')
        this.$router.push(`modelsList/${id}/editMenu`);
      else if(type === 'gift')
      this.$router.push(`modelsList/${id}/editmemories`);
      else if(type ==='visitcardpro')
      this.$router.push(`modelsList/${id}/editVisitPro`)
        else if(type ==='productpro')
      this.$router.push(`modelsList/${id}/productPro`)
        else if(type ==='photogallery')
      this.$router.push(`modelsList/${id}/photoGallery`)
        else if(type ==='pdfgallery')
      this.$router.push(`modelsList/${id}/pdfGallery`)
          else if(type ==='socialmedia')
      this.$router.push(`modelsList/${id}/editSocialModel`)
          else if(type ==='labelproduct')
      this.$router.push(`modelsList/${id}/productlabel`)

  

    },
    createPage(route) {
      this.$router.push(route);
    },
    deleteTemplate(id) {
      this.$modal.yesNo('توجه', 'آیا از حذف این ایتم مطمئن هستید؟')
        .then(res => {
          if (!res)
            return;

          this.loading = true;

          this.$api.delete('/qr/template/' + id)
            .then(() => {
              this.getData();
            }).catch(() => ({}))
            .finally(() => {
              this.loading = false;
            });
        })
    }
  }
}
</script>